import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAPIURL } from 'src/utils/url';
import { authTokenApiSlice } from 'src/api/auth-token-ApiSlice';
import { GetVersionResponse } from 'src/model/version.model';
import { RootState } from 'src/app/store';
import {
    TAG_FLOOR_VIEW_PRODUCTS,
    TAG_GET_DEVICES,
    TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS,
    TAG_GET_QUOTE,
    TAG_GET_USER_LABELS,
    TAG_NOTIFICATIONS,
    TAG_PINOUT_DEVICES,
    TAG_PROJECTS,
    TAG_PROJECT,
    TAG_STRIPE_SUBSCRIPTION,
    TAG_USER_CUSTOM_ITEMS,
    TAG_FLOOR_ROOMS_AND_RELATED,
    TAG_AUTOPLAN_TUTORIAL_STATUS,
    TAG_PROJECT_TREE,
    TAG_PROJECT_QUOTE_DATA,
    TAG_BILLING_DATA,
    TAG_MEASUREMENT_SYSTEM,
    TAG_PROJECT_USERS,
    TAG_PROFILE_SETTINGS,
    TAG_USER_INFO,
    TAG_PARTICIPANT_LISTS
} from "src/api/api-tags";

export const appApiSlice = createApi({
  reducerPath: 'app',
  baseQuery: fetchBaseQuery({
    baseUrl: getAPIURL(),
    prepareHeaders(headers, { getState }) {
      const token = authTokenApiSlice.endpoints.getAuthKey.select()(getState() as RootState).data?.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: [
      TAG_GET_DEVICES,
      TAG_PROJECTS,
      TAG_PROJECT,
      TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS,
      TAG_FLOOR_VIEW_PRODUCTS,
      TAG_GET_QUOTE,
      TAG_NOTIFICATIONS,
      TAG_PINOUT_DEVICES,
      TAG_GET_USER_LABELS,
      TAG_USER_CUSTOM_ITEMS,
      TAG_STRIPE_SUBSCRIPTION,
      TAG_FLOOR_ROOMS_AND_RELATED,
      TAG_AUTOPLAN_TUTORIAL_STATUS,
      TAG_PROJECT_TREE,
      TAG_PROJECT_QUOTE_DATA,
      TAG_BILLING_DATA,
      TAG_MEASUREMENT_SYSTEM,
      TAG_PROJECT_USERS,
      TAG_PROFILE_SETTINGS,
      TAG_USER_INFO,
      TAG_PARTICIPANT_LISTS
  ],
  endpoints: (builder) => ({
    getVersion: builder.query<GetVersionResponse, void>({
      query: () => `v1/app/version`,
    }),
  }),
});

export const { useGetVersionQuery } = appApiSlice;
